import { Component, OnInit } from '@angular/core'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'app-daily-log-template-select-modal',
  templateUrl: './daily-log-template-select-modal.component.html',
  styleUrls: ['./daily-log-template-select-modal.component.scss'],
})
export class DailyLogTemplateSelectModalComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  onClickClose(): void {
    this.modalService.dismiss()
  }

  onClickMoveToTemplate(): void {
    this.modalService.dismiss({ type: 'move' })
  }

  onClickCreate(): void {
    this.modalService.dismiss({ type: 'create' })
  }
}
